import { configureStore } from "@reduxjs/toolkit";
import MMSReducer from "intranet/features/MMS/MMSSlice";
import offerReducer from "intranet/features/customerarea/offersSlice";
import diasReducer from "intranet/features/dias/diasSlice";
import eCommerceReducer from "intranet/features/eCommerce/eCommerceSlice";
import labelsReducer from "intranet/features/labels/labelsSlice";
import notificationReducer from "intranet/features/notification/notificationSlice";
import pricetagsReducer from "intranet/features/pricetags/pricetagsSlice";
import sqlReducer from "intranet/features/sql/SQLSlice";
import trackingReducer from "intranet/features/tracking/trackingSlice";
import usersReducer from "intranet/features/users/usersSlice";

// NOTE: This is used to access the redux store outside of the react context
export const reduxStore = configureStore({
  reducer: {
    users: usersReducer,
    dias: diasReducer,
    sql: sqlReducer,
    mms: MMSReducer,
    pricetags: pricetagsReducer,
    offer: offerReducer,
    tracking: trackingReducer,
    ecommerce: eCommerceReducer,
    notification: notificationReducer,
    labels: labelsReducer,
  },
});

if (process.env.REACT_APP_ENV === "development" || process.env.REACT_APP_ENV === "test") {
  // NOTE: Expose the redux store to the window object for testing purposes
  window.reduxStore = reduxStore;
}
